export default "__VITE_ASSET__IgWDfC1a__"